import React from "react";
import Accordion from "../Accordion";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import BranchExpander, { LoadMoreTab } from "./BranchExpander";
import { BRANCH_TYPE } from "../../utilities/enums";
import { getTranslation } from "./translations";
import { AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from "../../utilities/automation";

const BranchListContainer = styled.div`
.accordion {
    font-size: 0.778rem;

    .address:hover {
        text-decoration: underline !important;
        color: ${props => props.theme.primary} !important;
    }

    .item-hours {

        .hour-container {
            min-width: 106px;
            display: inline-block;
            text-align: right;
            padding-bottom: 10px;
        }

        @media(max-width:991px) {
            width: 284px;
        }
    }
}
`;

function BranchAddressLink({ latitude = 0, longitude = 0, address_line_1, address_line_2 }: any) {
    const href = `https://www.google.com/maps/dir/?api=1&destination={${latitude},${longitude}}`;

    return (
        <a href={href} target="_blank" className="address text-primary text-decoration-none d-inline-block">
            <div>{address_line_1}</div>
            <div>{address_line_2}</div>
        </a>
    );
}

//format and list the BranchHours
function BranchHours({ label, hours }) {
    return (
        <>
            <div className="hour-label">
                <strong>{label}</strong>
            </div>
            <div className="hour-container" dangerouslySetInnerHTML={{ __html: hours }}></div>
        </>
    );
}

//hours container
function Hours({ lobby_hours, drive_up_hours, lobby_label, drive_label }) {
    return (
        <div className="item-hours pt-2">
            {Boolean(lobby_hours) && <BranchHours label={lobby_label} hours={lobby_hours} />}
            {Boolean(drive_up_hours) && <BranchHours label={drive_label} hours={drive_up_hours} />}
        </div>
    );
}

export interface IBranchResultsListProps {
    results: any;
    loading: boolean;
    type: BRANCH_TYPE;
    onLoadMore: () => void;
    loadMoreLabel: string;
    showMore: boolean;
    selectedId?: string;
    onSelect: (id: string) => void;
    itemIconClass?: string;
    lang: string;
}

const BranchList = (props: IBranchResultsListProps) => {
    const { results, onLoadMore, loadMoreLabel, loading, showMore, selectedId, onSelect, itemIconClass, lang } = props;
    const translations = getTranslation(lang);
    return (
        <BranchListContainer className="overflow-hidden w-100">
            <Accordion defaultOpen={0} data-test-id={createDataTestId({feature: AutomationTestIdFeature.BRANCH_LOCATOR, element: AutomationTestIdElementType.COLLECTION, specifier: 'mapList'})}>
                {results && results.map((result, index) => {
                    const hasDetailsUrl = Boolean(result.details_url);
                    const hasScheduleUrl = Boolean(result.schedule_url);
                    const isES = lang === 'es';
                    const isBranch = [BRANCH_TYPE.MACU, BRANCH_TYPE.MACU_SATURDAYS, BRANCH_TYPE.MACU_SPANISH].includes(props.type);
                    return (
                        <BranchExpander
                            className="expander"
                            selectedId={selectedId}
                            waitTime={result.wait_time}
                            distance={result.distance.toFixed(2)}
                            isBranch={isBranch}
                            isBranchOpen={result.is_branch_open}
                            isDriveUpOpen={result.is_drive_up_open}
                            opensAt={result.opens_at}
                            key={result.id}
                            id={String(result.id)}
                            index={index}
                            itemIconClass={itemIconClass}
                            title={(lang === 'es' && result.headline_es) ? result.headline_es : result.headline}
                            street={result.address_line_1}
                            onSelect={onSelect}
                            lang={lang}
                            innerClassname="">
                            <div>
                                <BranchAddressLink {...result} />
                                <div className="my-2">
                                    {result.phone}
                                </div>
                                <Hours
                                    lobby_hours={isES && result.lobby_hours_es ? result.lobby_hours_es : result.lobby_hours}
                                    drive_up_hours={isES && result.drive_up_hours_es ? result.drive_up_hours_es : result.drive_up_hours}
                                    lobby_label={translations.lobbyHours}
                                    drive_label={translations.driveUpHours} />
                                {isBranch &&
                                    <div>
                                        {hasDetailsUrl && <Button variant="primary" className="branch-details-btn p-2 mr-2 mb-2" href={`${lang === 'es' ? '/es' : ''}${result.details_url}`}>
                                            {translations.branchDetails}
                                        </Button>}
                                        {hasScheduleUrl && <Button variant="outline-primary" className="schedule-btn p-2 mb-2" href={result.schedule_url}>
                                            {translations.scheduleAppointment}
                                        </Button>}
                                    </div>
                                }
                            </div>
                        </BranchExpander>
                    );
                })}
                {showMore && <LoadMoreTab showSpinner={loading} onClick={onLoadMore} loadMoreLabel={loadMoreLabel} />}
            </Accordion>
        </BranchListContainer>
    );
};

export default BranchList;
